export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',

	kpiGrid: 'grid grid-cols-1 gap-md sm:grid-cols-2 xl:grid-cols-4',
	kpiCard: 'flex flex-col gap-3xs rounded-lg border border-subtle bg-white px-md py-sm',
	kpiLabel: 'text-[11px] font-medium uppercase tracking-wider text-subtle',
	kpiValue: 'text-[26px] font-semibold leading-tight tabular-nums text-default',
	kpiSub: 'text-[12px] text-subtle',

	chartCard: 'flex flex-col gap-sm rounded-lg border border-subtle bg-white px-md py-sm',
	chartTitle: 'text-[14px] font-semibold text-default',
	dayRow: 'flex items-center gap-sm',
	dayLabel: 'w-[72px] shrink-0 text-[11px] tabular-nums text-subtle',
	dayTrack: 'flex h-[14px] flex-1 overflow-hidden rounded-full bg-grey-50',
	dayTotal: 'w-[56px] shrink-0 text-right text-[11px] tabular-nums text-subtle',

	segmentClean: 'h-full bg-green-500',
	segmentFlagged: 'h-full bg-amber-200',
	segmentScrubbed: 'h-full bg-amber-500',
	segmentErrors: 'h-full bg-red-500',

	legend: 'flex flex-wrap items-center gap-md',
	legendItem: 'inline-flex items-center gap-3xs text-[11px] text-subtle',
	legendDot: 'inline-block h-2xs w-2xs shrink-0 rounded-full',

	reportsSection: 'flex flex-col gap-sm',
	reportsToolbar: 'flex flex-wrap items-center justify-between gap-sm',
	reportsRangeGroup: 'flex items-center gap-2xs',
	reportsRangeBtn: 'rounded-md px-xs py-3xs text-[12px] transition-colors',
	reportsRangeBtnActive: 'bg-purple-500 text-white',
	reportsRangeBtnIdle: 'bg-grey-25 text-default hover:bg-grey-50',
	reportsEmpty: 'rounded-md border border-subtle bg-grey-25 px-xl py-xl',
	reportsEmptyTitle: 'text-[14px] font-semibold text-default',
	reportsEmptyBody: 'mt-3xs text-[12px] text-subtle',
	moduleReport: 'flex flex-col gap-md',
	moduleReportTitle: 'text-[16px] font-semibold capitalize text-default',
	scoreGrid: 'grid grid-cols-1 gap-md md:grid-cols-3',
	scoreCard: 'flex flex-col gap-xs rounded-md border border-subtle bg-white px-lg py-md',
	scoreLabel: 'text-[11px] uppercase tracking-wider text-subtle',
	scoreValue: 'flex items-baseline gap-xs text-[36px] font-semibold tabular-nums text-default',
	scoreAverage: 'text-[36px] font-semibold tabular-nums',
	scoreMax: 'text-[16px] text-subtle',
	scoreSub: 'text-[12px] text-subtle',
	distribution: 'rounded-md border border-subtle bg-white px-md py-sm',
	distributionHeader: 'mb-xs flex items-center justify-between',
	distributionTitle: 'text-[12px] font-semibold text-default',
	distributionBars: 'flex items-end gap-2xs',
	distributionColumn: 'flex flex-1 flex-col items-center gap-3xs',
	distributionTrack: 'flex h-[60px] w-full items-end',
	distributionBar: 'w-full rounded-t-sm bg-purple-500',
	distributionStar: 'text-[11px] tabular-nums text-subtle',
	distributionCount: 'text-[10px] tabular-nums text-default',
	reportTableWrap: 'overflow-x-auto rounded-md border border-subtle bg-white',
	reportTable: 'min-w-full text-left text-[13px]',
	reportTableHead: 'border-b border-subtle bg-grey-25 text-[11px] font-medium uppercase tracking-wider text-subtle',
	reportTh: 'px-md py-xs',
	reportRow: 'border-b border-subtle/50',
	reportExpandedRow: 'border-b border-subtle/50 bg-grey-25/60',
	reportDayCell: 'px-md py-xs text-[12px] font-medium text-default',
	reportNumCell: 'px-md py-xs text-[12px] tabular-nums text-default',
	reportCell: 'px-md py-xs',
	reportExpandedCell: 'px-md py-sm',
	reportToggle:
		'rounded-md border border-subtle bg-white px-xs py-3xs text-[12px] text-default transition-colors hover:bg-grey-25',
	consolidated: 'rounded-md border border-subtle bg-white px-lg py-md',
	consolidatedTitle: 'text-[11px] font-medium uppercase tracking-wider text-subtle',
	consolidatedBody: 'mt-xs max-w-[78ch] text-[13px] leading-6 text-default',
	consolidatedGrid: 'mt-md grid grid-cols-1 gap-md md:grid-cols-3',
	consolidatedListTitle: 'text-[12px] font-semibold text-default',
	consolidatedList: 'mt-2xs list-disc space-y-2xs pl-md text-[12px] leading-5 text-subtle',
	consolidatedNotice: 'text-[12px] text-subtle',
	consolidatedError: 'text-[12px] text-error',
	reportsSkeletonTitle: 'h-[24px] w-[200px] animate-pulse rounded-md bg-grey-25',
	reportsSkeletonCard: 'h-[112px] animate-pulse rounded-md bg-grey-25',
	reportsSkeletonTable: 'h-[240px] animate-pulse rounded-md bg-grey-25',
	sectionH: 'text-[15px] font-semibold leading-tight tracking-tight text-default',

	callout: 'flex items-start gap-xs rounded-lg border border-purple-100 bg-purple-25 px-md py-sm',
	calloutText: 'text-[12px] leading-tight text-default',
	calloutLink: 'font-medium text-purple-700 underline underline-offset-2',
};
